import React from 'react';
import MaterialSelect from './materialSelect';
import SaunaImageContainer from '../containers/SaunaImageContainer';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import localization from '../helpers/localization.js';
import StoveSelectionContainer from '../containers/StoveSelectionContainer';



const stoveAndLigthingSelectionPage = ({
    nextPage, prevPage
    }) => {
    

    return(<div className="page">
    <SaunaImageContainer/>
    <div className="materialSelections">
    <Row>
        <Col md={12} sm={12}><StoveSelectionContainer/></Col>  
    </Row>
            <div className="changePhaseRow">
                <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
                <span className="orangeButton changePhaseButton" onClick={() => { nextPage() }}> <span className="buttonTxt"> {localization.nextPhase} &#8594;</span></span>
            </div>
    </div>
    </div>
    )}
  export default stoveAndLigthingSelectionPage
  